import { isTauri } from '@tauri-apps/api/core';

/** Fora do app (navegador) só o modo Viewer funciona: não há captura de tela nem SendInput. */
export const INSIDE_APP = isTauri();

/** Tela do aplicativo no navegador (`npm run dev:ui`). Não existe em produção. */
export const PREVIEW_HOST =
  import.meta.env.DEV && !INSIDE_APP && new URLSearchParams(window.location.search).get('host') === '1';

/**
 * Sem VITE_SIGNALING_URL, o app procura o servidor na própria máquina e o navegador no mesmo
 * endereço de onde a página veio — assim uma troca de IP na rede não quebra nada. Em produção
 * a página é servida pelo próprio servidor de signaling, atrás de HTTPS.
 */
export const SIGNALING_URL = import.meta.env.VITE_SIGNALING_URL || defaultSignalingUrl();

function defaultSignalingUrl(): string {
  if (INSIDE_APP) return 'ws://localhost:8787/ws';
  if (import.meta.env.DEV) return `ws://${location.hostname}:8787/ws`;
  return `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;
}

/** A API REST (contas e empresas) mora no mesmo servidor do signaling: ws://host/ws → http://host. */
export const API_URL = SIGNALING_URL.replace(/^ws/, 'http').replace(/\/ws\/?$/, '');

/** Força o uso do TURN (iceTransportPolicy: relay) para testar o caminho de relay. */
export const FORCE_RELAY = import.meta.env.VITE_FORCE_RELAY === 'true';
